import { render, staticRenderFns } from "./OrderQuoteForm.vue?vue&type=template&id=2415ee68&"
import script from "./OrderQuoteForm.vue?vue&type=script&lang=js&"
export * from "./OrderQuoteForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports